export default "__VITE_ASSET__63b6c04d__"